import { useSnackbar } from './use-snackbar';

export const useNotifications = () => {
  const { showErrorAlert, showSuccessAlert, showInfoAlert } = useSnackbar();

  return { showSuccessAlert, showErrorAlert, showInfoAlert };
};
